module.exports = {
      id: "angle-right-usage",
      viewBox: "0 0 192 512",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#angle-right",
      toString: function () {
        return this.url;
      }
    }